import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IVendorState } from './vendor.types';
import { IVendorData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IVendorState = {
  version: 1,
  vendors: [] as IVendorData[]
};

const namespaced = true;

export const vendor: Module<IVendorState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
